






















import { User } from '@/model/Profile';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
    @Prop() user!: User | null;
}
